class CollapsibleContentTabs extends HTMLElement {
  connectedCallback() {
    const tablist = this.querySelector('[role="tablist"]');
    if (!tablist) return;

    this._tablist = tablist;
    this._tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    this._panels = this._tabs
      .map((tab) => tab.getAttribute('aria-controls'))
      .map((panelId) => (panelId ? this.querySelector(`#${panelId}`) : null));

    this._tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index, true));
    });

    tablist.addEventListener('keydown', (event) => {
      const key = event.key;
      if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;

      event.preventDefault();
      const currentIndex = this._tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      const lastIndex = this._tabs.length - 1;

      let nextIndex = currentIndex >= 0 ? currentIndex : 0;
      if (key === 'Home') nextIndex = 0;
      if (key === 'End') nextIndex = lastIndex;
      if (key === 'ArrowUp' || key === 'ArrowLeft') nextIndex = currentIndex <= 0 ? lastIndex : currentIndex - 1;
      if (key === 'ArrowDown' || key === 'ArrowRight') nextIndex = currentIndex >= lastIndex ? 0 : currentIndex + 1;

      this.activate(nextIndex, true);
    });

    const selectedIndex = this._tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
    this.activate(selectedIndex >= 0 ? selectedIndex : 0, false);
  }

  activate(index, shouldFocus) {
    this._tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this._panels.forEach((panel, i) => {
      if (!panel) return;
      panel.toggleAttribute('hidden', i !== index);
    });

    if (shouldFocus) this._tabs[index]?.focus();
  }
}

customElements.define('collapsible-content-tabs', CollapsibleContentTabs);

function openFirstAccordionOnMobile() {
  if (!window.matchMedia('(max-width: 989px)').matches) return;

  document.querySelectorAll('.collapsible-content[data-open-first-mobile="true"]').forEach((root) => {
    const accordionRoot = root.querySelector('.collapsible-content__accordion');
    if (!accordionRoot) return;

    const firstDetails = accordionRoot.querySelector('details');
    if (!firstDetails) return;

    firstDetails.setAttribute('open', '');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', openFirstAccordionOnMobile);
} else {
  openFirstAccordionOnMobile();
}

// Crown SVG resizing (copied from rich-text approach)
function resizeCollapsibleCrowns() {
  document.querySelectorAll('.collapsible-content__crown').forEach((crown) => {
    const svg = crown.querySelector('svg');
    if (!svg) return;

    const isMobile = window.innerWidth <= 989;
    const styles = window.getComputedStyle(crown);

    const widthFromData = isMobile ? crown.dataset.crownWidthMobile : crown.dataset.crownWidth;
    const fallbackFromData = crown.dataset.crownWidth;

    const widthVar = isMobile ? '--crown-width-mobile' : '--crown-width';
    const fallbackWidthVar = '--crown-width';

    const targetWidth =
      parseFloat(widthFromData) ||
      parseFloat(fallbackFromData) ||
      parseFloat(styles.getPropertyValue(widthVar)) ||
      parseFloat(styles.getPropertyValue(fallbackWidthVar)) ||
      520;

    const targetOpacity =
      parseFloat(crown.dataset.crownOpacity) ||
      parseFloat(styles.getPropertyValue('--crown-opacity')) ||
      0.12;

    let originalWidth = parseFloat(svg.getAttribute('width')) || (svg.viewBox?.baseVal?.width || 100);
    let originalHeight = parseFloat(svg.getAttribute('height')) || (svg.viewBox?.baseVal?.height || 100);

    // Ensure viewBox exists so scaling is consistent
    try {
      if (!svg.hasAttribute('viewBox') || !svg.viewBox?.baseVal?.width) {
        if (originalWidth && originalHeight) {
          svg.setAttribute('viewBox', `0 0 ${originalWidth} ${originalHeight}`);
        } else if (typeof svg.getBBox === 'function') {
          const bbox = svg.getBBox();
          if (bbox.width && bbox.height) {
            originalWidth = bbox.width;
            originalHeight = bbox.height;
            svg.setAttribute('viewBox', `0 0 ${originalWidth} ${originalHeight}`);
          }
        }
      }
    } catch (e) {
      // ignore
    }

    const scale = targetWidth / originalWidth;
    const finalHeight = originalHeight * scale;

    // Force sizes on svg
    svg.setAttribute('width', targetWidth);
    svg.setAttribute('height', finalHeight);
    svg.style.width = `${targetWidth}px`;
    svg.style.height = `${finalHeight}px`;
    svg.style.maxWidth = `${targetWidth}px`;
    svg.style.minWidth = `${targetWidth}px`;
    svg.style.maxHeight = `${finalHeight}px`;
    svg.style.minHeight = `${finalHeight}px`;
    svg.style.opacity = `${targetOpacity}`;

    // Force sizes on container
    crown.style.width = `${targetWidth}px`;
    crown.style.minWidth = `${targetWidth}px`;
    crown.style.maxWidth = `${targetWidth}px`;
    crown.style.height = `${finalHeight}px`;
    crown.style.minHeight = `${finalHeight}px`;
    crown.style.maxHeight = `${finalHeight}px`;
  });
}

// Run multiple times for reliability (same as rich-text)
resizeCollapsibleCrowns();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', resizeCollapsibleCrowns);
}
window.addEventListener('load', resizeCollapsibleCrowns);
window.addEventListener('resize', resizeCollapsibleCrowns);
setTimeout(resizeCollapsibleCrowns, 100);
setTimeout(resizeCollapsibleCrowns, 500);


